import { CustomFormatters } from '@earzzai/i18n';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import translationDE from './locales/de/dashboard.json';
import translationEN from './locales/en/dashboard.json';
import translationTH from './locales/th/dashboard.json';

const resources = {
  en: {
    dashboard: translationEN
  },
  de: {
    dashboard: translationDE
  },
  th: {
    dashboard: translationTH
  }
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(initReactI18next)
  .use(ICU)
  .use(LanguageDetector)
  .use(CustomFormatters)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'th'],
    nonExplicitSupportedLngs: true,
    ns: ['dashboard'],
    defaultNS: 'dashboard',

    interpolation: {
      escapeValue: false
    },

    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLang',
      convertDetectedLanguage: lng => {
        if (lng == 'en') {
          // Majority of customers are from the UK. If there is no region
          // information detected, assume en-GB.
          return 'en-GB';
        }
        return lng;
      }
    }
  });

export const resetLanguagePreference = async () => {
  localStorage.removeItem('i18nextLang');
  await i18n.changeLanguage();
};

export { i18n };
